import { CommonModule, isPlatformBrowser } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, HostListener, inject, PLATFORM_ID } from '@angular/core';
import { Badge } from './Badge';
import { Device } from '../../app.component';

@Component({
    selector: 'app-badges',
    imports: [CommonModule],
    templateUrl: './badges.component.html',
    styleUrl: './badges.component.less'
})
export class BadgesComponent implements AfterViewInit {

  private cdr = inject(ChangeDetectorRef);
  private platformId = inject(PLATFORM_ID);

  device: string = Device.Desktop;
  Device = Device;

  showImages: boolean = false;

  badges: Badge[] = []

  constructor() {
    this.initializeBadges();
  }

  ngAfterViewInit() {
    this.onResize();
  }

  private initializeBadges() {
    const ibmBadge = new Badge("DevOps Capstone", $localize`La obtención de este certificado de IBM en DevOps e Ingeniería de Software ha sido un avance significativo en mi trayectoria profesional. He adquirido habilidades prácticas en metodologías Agile y Scrum, herramientas de CI/CD y tecnologías Cloud Native. Además, he mejorado mi capacidad en la programación con Python y el desarrollo de aplicaciones basadas en microservicios. Este certificado refleja mi habilidad para adaptarme a las tendencias actuales en software y mi compromiso con el desarrollo profesional continuo en un campo tecnológico en constante evolución.`, "assets/pdf/Coursera_UV53G5T5DC9L.pdf");
    ibmBadge.addImage("assets/images/ibm_badge.webp", 300, 300);
    ibmBadge.addMobileImage("assets/images/ibm_badge_mobile.webp", 135, 135);
    this.badges.push(ibmBadge);

    const googleBadge = new Badge("Certificado de ciberseguridad de Google", $localize`Este certificado de Google ha fortalecido mi perfil profesional con habilidades clave en ciberseguridad. He desarrollado competencias en seguridad de red y análisis de amenazas, y he aprendido a manejar herramientas fundamentales como Linux y Python. Esta formación me posiciona para roles importantes en un sector en expansión, demostrando mi compromiso con el aprendizaje continuo y la adaptabilidad en el ámbito tecnológico.`, "assets/pdf/Coursera_GSX7PLP6MJPT.pdf")
    googleBadge.addImage("assets/images/google_badge.webp", 300, 300);
    googleBadge.addMobileImage("assets/images/google_badge_mobile.webp", 135, 135);
    this.badges.push(googleBadge);
  }

  clickBadge(badge_number: number) {
    const badge = this.badges[badge_number];
    if (badge && badge.url) {
      window.open(badge.url, '_blank');
    }
  }
  

  @HostListener('window:resize')
  onResize() {
    if (isPlatformBrowser(this.platformId)) {
      const screenWidth = window.innerWidth;
      const newDevice = screenWidth > 815 ? Device.Desktop : Device.Mobile;
      
      if (this.device !== newDevice) {
        this.device = newDevice;
        this.cdr.detectChanges();
      }
    }
  }

  @HostListener("window:scroll")
  onScroll() {
    if (isPlatformBrowser(this.platformId) && this.showImages === false) {
      const badgesSection = document.getElementById('badges');
      if (!badgesSection) return;

      const { top, bottom } = badgesSection.getBoundingClientRect();
      if (top <= window.innerHeight && bottom >= 0) {
        this.showImages = true;
      }
    }
  }

}
